import { render, staticRenderFns } from "./SecaoSegmentos.vue?vue&type=template&id=656cf98d&"
import script from "./SecaoSegmentos.vue?vue&type=script&async=true&lang=js&"
export * from "./SecaoSegmentos.vue?vue&type=script&async=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports